<!-- 电脑端发送消息栏 -->
<template>
    <div class="input-content">
        <div id="microphone-block" class="top-toolbar" v-show="microphoneShow">
            <div class="green-ball"></div>
            <span class="microphone-text">
                正在录音...({{recordTime}})s
            </span>
            <div class="float-r mt-3">
                <el-button size="mini" type="primary" plain @click="sendVoice">发送</el-button>
                <el-button size="mini" @click="cancelVoice">取消</el-button>
            </div>
        </div>
        <div class="top-toolbar" v-show="multipleShow">
            <span class="microphone-text">已选择{{checkNum}}条内容</span>
            <div class="float-r mt-3">
                <el-button size="mini" type="primary" plain @click="copyClick">复制</el-button>
                <el-button size="mini" @click="closeMultiple">取消</el-button>
            </div>
        </div>
        <div class="toolbar">
            <el-popover
                placement="top"
                popper-class="emoji-pop"
                v-model="popShow"
                v-if="!isIE"
                trigger="click">
                <div class="cursor" style="font-size:24px">
                    <span v-for="(item,key) in emojis" :key="key" @click="setEmoji(item.char)">{{item.char}}</span>
                </div>
                <span id="smileSpan" :class="[pageSize === 'small' ? 'button-icon':'','iconfont','icon-biaoqing-xue', closedChat || clickItem.groupStatus === 2 ? 'tool-disabled':'tool-active']" slot="reference"></span>
            </el-popover>
            <span title="图片" id="picSpan" :class="[pageSize === 'small' ? 'button-icon':'','iconfont','icon-fasongtupian',closedChat || clickItem.groupStatus === 2 ? 'tool-disabled':'tool-active']" @click="pictureClick"></span>
            <span title="截图" v-if="pageSize !== 'small' && !isIE" id="screenShot" :class="[pageSize === 'small' ? 'button-icon':'','iconfont','icon-jietu',closedChat || clickItem.groupStatus === 2 ? 'tool-disabled':'tool-active']" @click="screenShoot"></span>
            <el-upload
                ref="upload"
                :action="action"
                :on-change="handleChange"
                :show-file-list="false"
                :auto-upload="true"
                :headers="headers"
                :on-success="successUpload"
                :class="['inline-block','file-upload',closedChat || clickItem.groupStatus === 2 ? 'tool-disabled':'tool-active']"
                v-if="pageSize !== 'small' && otherSys !== 'applet'"
            >
                <span title="文件" id="fileSpan" :class="[pageSize === 'small' ? 'button-icon':'','iconfont','icon-fasongwenjian',closedChat || clickItem.groupStatus === 2 ? 'tool-disabled':'tool-active']"></span>
            </el-upload>
            <!--  :http-request="uploadRequest"-->
            <span v-if="!isIE && otherSys !=='ris' && otherSys !== 'applet'" title="语音" id="microphone" :class="[pageSize === 'small' ? 'button-icon':'','iconfont','icon-yuyinliaotian',closedChat || clickItem.groupStatus === 2 ? 'tool-disabled':'tool-active']" @click="microphoneClick"></span>
            <span v-if="showVideo && pageSize !== 'small' && otherSys !=='ris' && otherSys !== 'applet'" title="视频" :class="[pageSize === 'small' ? 'button-icon':'','iconfont','icon-shipin',closedChat || clickItem.groupStatus === 2 ? 'tool-disabled':'tool-active']" @click="sendVideoClick"></span>
            <span title="聊天记录" id="history" :class="[pageSize === 'small' ? 'button-icon':'','iconfont','icon-liaotianjilu',closedChat || clickItem.groupStatus === 2 ? 'tool-disabled':'tool-active']" @click="historyClick(true)"></span>
            <!-- <span v-if="userType === 1 && otherSys === 'applet'" title="开单" :class="[pageSize === 'small' ? 'button-icon':'','iconfont','icon-kaidan',clickItem.groupStatus === 2 ? 'tool-disabled':'tool-active']" @click="openLickClick"></span> -->
            <span v-if="pageSize === 'small'" title="更多" :class="[pageSize === 'small' ? 'button-icon':'','iconfont','icon-gengduo',closedChat || clickItem.groupStatus === 2 ? 'tool-disabled':'tool-active']" @click="moreClick"></span>
            <button id="send" :class="[pageSize === 'small' ? 'big-size':'',closedChat || clickItem.groupStatus === 2 ? 'tool-disabled':'tool-active']" @click="sendMsg"><span class="send-icon iconfont icon-fasong-copy"></span>发送</button>
        </div>
        <div class="more-bar" v-if="showMoreBar">
            <!-- <div class="one-box">
                <el-upload
                    ref="upload"
                    :action="action"
                    :on-change="handleChange"
                    :show-file-list="false"
                    :auto-upload="true"
                    :http-request="uploadRequest"
                    :on-success="successUpload"
                    class="inline-block file-upload"
                >
                    <span title="文件" id="fileSpan" :class="['iconfont','icon-fasongwenjian','tool-box']"></span>
                </el-upload>
                <span>文件</span>
            </div> -->
            <div class="one-box">
                <div class="tool-box iconfont icon-shipin" @click="sendVideoClick"></div>
                <span>视频</span>
            </div>
        </div>
        <div id="input-main" :class="closedChat || clickItem.groupStatus === 2 ? 'tool-disabled':'tool-active'" rows="5" contenteditable="true"></div>
        <span v-if="clickItem.type === 1 && (questNum>0 || questNum===-1) && !closedChat && surplusTime && otherSys === 'applet'" class="quest-num">- <span v-if="groupOutTime > 0">本次问诊{{surplusTime}}后结束</span><span v-if="allQuestNum >0 && questNum>-1">,<span v-if="userType === 1">患者</span>还剩<strong style="font-size:18px;color:#000">{{questNum}}</strong>次提问</span> -</span>
        <span v-else-if="clickItem.type === 1 && otherSys === 'applet'" class="quest-num">- 本次问诊已结束 -</span>
    </div>
</template>

<script>
// import recordUtils from '../../libs/recordUtils/voice-utils'
import emojis from '../../assets/emojis.json'
import screenShotPlugin from 'js-web-screen-shot'
require('../../../static/webRecorderUtil/WebAudioRecorder.js')
// import screenShotPlugin from '../../libs/screenshotPlugin/screenShotPlugin.common.js'
// const {voiceTime, API_ROOT} = require('../../../static/config.js')
/* const config = require('../../../static/config.js')
const API_ROOT = window.httpConfig.API_ROOT
const voiceTime = window.httpConfig.voiceTime */

export default {
  name: '',
  mixins: [],
  components: {},
  props: {
    clickItem: {
      Object,
      default: () => {}
    },
    showVideo: {
      Boolean,
      default: ''
    },
    pageSize: {
      String,
      default: 'large'
    },
    userType: {
      Number,
      default: 0
    },
    recordTime: {// 录制时长
      Number,
      default: 0
    },
    checkNum: {// 已选条目数
      Number,
      default: 0
    },
    action: {
      String,
      default: ''// 上传的地址
    },
    questNum: {// 剩余体温次数
      Number,
      default: 0
    },
    multipleShow: {
      Boolean,
      default: false
    },
    closedChat: {
      Boolean,
      default: false
    },
    otherSys: {
      String,
      default: ''
    },
    groupOutTime: {// 会话过期时长
      String,
      default: null
    },
    groupCreateTime: {// 会话创建时间
      String,
      default: null
    },
    allQuestNum: { // 提问次数
      Number,
      default: 0
    }
  },
  data () {
    return {
      microphoneShow: false,
      //   recordTime: this.voiceTime,
      //   action: this.API_ROOT + '/sysFileInfo/upload', // 改从外面传进来
      emojis: emojis,
      popShow: false,
      //   multipleShow: false,
      //   checkNum: 0,
      showMoreBar: false,
      //   questNum: -1,
      isIE: false,
      surplusTime: '' // 剩余时间
    }
  },
  watch: {
    groupCreateTime: {
      handler (val) {
        if (this.sTime) clearInterval(this.sTime)
        if (val) {
          this.setSurplusTime()
          this.sTime = setInterval(() => {
            this.setSurplusTime()
          }, 1000)
        }
      },
      immediate: true
    }
  },
  computed: {},
  created () {
    this.isIE = this.$chatUtils.isIE()
    let token = localStorage.getItem('token')
    this.headers = {
      'Authorization': 'Bearer ' + token
    }
  },
  mounted () {
    // this.sendByKeyup()
    // this.pasteContent()
    // this.initWebRecorder()
  },
  methods: {
    setSurplusTime () {
      if (this.groupOutTime) { // 有会话时长规定
        if (this.groupCreateTime) {
          let time = this.$dayjs().diff(this.$dayjs(this.groupCreateTime))// 差异毫秒数
          let outTime = Number(this.groupOutTime) * 60 * 1000
          if (time > outTime) {
            this.surplusTime = ''
            // this.$emit('update:closedChat', true)
            this.$parent.$parent.closedChat = true
          } else {
            let stime = outTime - time
            stime = stime + 60 * 1000
            let day = Math.floor(stime / (1000 * 60 * 60 * 24)) // 天数
            stime = stime % (1000 * 60 * 60 * 24)// 剩余时间
            let hour = Math.floor(stime / (1000 * 60 * 60))// 小时
            stime = stime % (1000 * 60 * 60)// 剩余小时
            let minute = Math.floor(stime / (1000 * 60)) // 分钟
            // let second = Math.floor(stime % (1000 * 60) / 1000)// 剩余秒数
            this.surplusTime = `${day}天${hour}小时${minute}分钟`
          }
        } else {
          this.surplusTime = ''
        }
      }
    },
    sendByKeyup () {
      // 按回车发送聊天内容
      document.getElementById('input-main').onkeyup = (event) => {
        if (event.keyCode === 13) {
          event.preventDefault()
          this.sendMsg()
        }
        return false
      }
      document.getElementById('input-main').onkeydown = (event) => {
        if (event.keyCode === 13) {
          event.preventDefault()
          return false
        }
      }
    },
    initWebRecorder () {
      let audioContext = new AudioContext()
      /* if (audioContext.createScriptProcessor == null) {
        audioContext.createScriptProcessor = audioContext.createJavaScriptNode
      }
      let mixer = audioContext.createGain()
      mixer.connect(audioContext.destination) */
      // eslint-disable-next-line no-undef
      this.audioRecorder = new WebAudioRecorder(audioContext, {
        workerDir: 'static/webRecorderUtil/',
        encoding: 'mp3'
      })
      // 录音完成事件，有录音返回就发送
      this.audioRecorder.onComplete = (recorder, blob) => {
        /* this.$chatUtils.blobToBase64(blob).then(val => {
          console.log('生成的base64', val)
          let params = {
            Data: val,
            Time: 30
          }
          this.sendMsg('audio', params)
        }) */
        let url = URL.createObjectURL(blob)
        this.downloadFile2(url, '语音')
      }
    },
    downloadFile2 (url, name) {
      var a = document.createElement('a')
      a.setAttribute('href', url)
      a.setAttribute('download', name)
      a.setAttribute('target', '_blank')
      let clickEvent = document.createEvent('MouseEvents')
      clickEvent.initEvent('click', true, true)
      a.dispatchEvent(clickEvent)
    },
    pasteContent () {
      // 粘贴
      const target = document.querySelector('#input-main')
      //   let that = this
      target.addEventListener('paste', (e) => {
        if (!(e.clipboardData && e.clipboardData.items)) {
          return
        }
        // console.log('粘贴的对象', e.clipboardData.items)
        // for (var i = 0, len = e.clipboardData.items.length; i < len; i++) { // 因为回粘贴出多份所以注释
        var item = e.clipboardData.items[0]
        console.log('item', item)
        if (item.kind === 'file' && item.type.match(/^image\//i)) {
          var f = item.getAsFile()
          var reader = new FileReader()
          reader.onload = function (e) {
            let img = document.createElement('img')
            img.setAttribute('style', 'max-width:100px')
            img.setAttribute('class', 'local')
            img.setAttribute('src', e.target.result)
            document.getElementById('input-main').appendChild(img)// 将img添加到div中
            //   that.insertCont(img)
          }
          reader.readAsDataURL(f)// 读取为DataURL,改为上传图片的话需要blob,方法改为readAsBinaryString,onload就会获取到blob
        } else if (item.kind === 'string' && item.type === 'text/plain') {
          /* let span = document.createElement('span')
          let text = document.createTextNode(e.clipboardData.getData('text'))
          span.appendChild(text)
          document.getElementById('input-main').appendChild(span) */
          // that.insertCont(span)

          let word = e.clipboardData.getData('text')
          let dom = document.getElementById('input-main')
          dom.innerHTML += word
        } else if (item.kind === 'string' && item.type === 'text/html') { // samesite同站策略问题，不保存图片地址了
          item.getAsString((e) => { // 获取到粘贴的html
            console.log('getAsString', e)
            if (e.indexOf('base64') > -1) {
              let startIndex = e.indexOf('src="') + 5
              let endIndex = e.indexOf('"', startIndex)
              let src = e.substring(startIndex, endIndex)
              let img = document.createElement('img')
              img.setAttribute('style', 'width:100px')
              img.setAttribute('class', 'online')
              img.setAttribute('src', src)
              document.getElementById('input-main').appendChild(img)
              // that.insertCont(img)
            }
          })
        }
        // }
        e.preventDefault()

        this.$nextTick(() => {
          setTimeout(() => {
            this.moveTo()// 把光标移至最后
          }, 300)
        })
      })
    },
    sendMsg (type, params) {
      this.$emit('sendMsg', type, params)
    },
    emojiToStr (val) { // 表情转换编码
      for (const key in emojis) {
        // eslint-disable-next-line no-undef
        const el = emojis[key]
        // val = val.replaceAll(el.char, el.keywords)
        let reg = new RegExp(el.char, 'g')
        val = val.replace(reg, el.keywords)// 去除掉回车带来的换行
      }
      return val
    },
    microphoneClick () {
      if (this.microphoneShow) { // 打开状态
        this.cancelVoice()
      } else { // 关闭状态
        this.microphoneShow = true
        this.$emit('startVoice')
        /*  recordUtils.onStartVoice((time) => {
          this.recordTime = time
          if (this.recordTime === 0) { // 倒计时结束就自动发送语音
            this.sendVoice()
          }
        }) */
      }
    },
    sendVideoClick () { // 发起视频
      this.$emit('goInVideo')
    },
    sendVoice () { // 结束语音并发送语音
      this.microphoneShow = false
      this.$emit('sendVoice')
    },
    cancelVoice () {
      this.microphoneShow = false
      this.$emit('cancelVoice')
    },
    pictureClick () {
      // 图片click
    //   document.getElementById('pic-input').click()
      this.$emit('pictureClick')
    },
    picChooseChange (e) {
      // 图片选择
      var reader = new FileReader()
      reader.onload = function (e) {
        const str =
                "<img style='max-width:100px' class='local' src='" +
                e.target.result +
                "'/>"
        let ele = document.querySelector('#input-main')
        ele.innerHTML = ele.innerHTML + str
      }
      reader.readAsDataURL(e.target.files[0])
      document.getElementById('pic-input').value = ''
    },
    fileClick () {
      document.getElementById('file-input').click()
    },
    handleChange (file, fileList) {
      this.uploadFile = null
      /*  if (file.status === 'ready') {
        if (file.name.indexOf('.txt') > -1) {
          this.$chatUtils.txt2utf8(file.raw, (blob) => {
            let newFile = this.$chatUtils.blobToFile(blob, file.name, 'text/plain')
            this.uploadFile = newFile
            this.$refs.upload.submit()
          })
        } else {
          this.uploadFile = file
        }
      } */
      /* var _this = this
      if (file.raw) {
        let reader = new FileReader()
        reader.onload = function (e) {
          _this.contentHtml = e.target.result
          console.log('e.target.result', e.target.result)
        }
        reader.readAsText(file.raw, 'utf8')
      }
      console.log(file, fileList) */
    },
    /* uploadRequest (param) { // 手动上传文件
      if (this.uploadFile) {
        uploadFileApi({file: this.uploadFile}).then(data => {
          this.sendMsg('file', JSON.stringify(data))
        })
      }
    }, */
    successUpload (response, file, fileList) {
      this.$emit('successUpload', response, file, fileList)
    },
    smileSpanClick () {

    },
    // 向聊天框填入表情
    setEmoji (char) {
    //   let node = document.createElement('img')
    //   node.setAttribute('src', require(`../assets/emoji/${number}.gif`))
      document.getElementById('input-main').innerHTML += char
      //   this.insertCont(char)
      this.popShow = false
    },
    screenShoot () {
      // 截图
      // 可以通知父页面调用系统截图方法截图
      if (this.otherSys === 'ris') { // 汪小梅嵌套可以调用系统截图
        let data = {
          type: 'screenCapture'
        }
        this.$chatUtils.postToParent(data)
      } else { // 其余用web截图
        // eslint-disable-next-line no-new
        new screenShotPlugin({enableWebRtc: false, completeCallback: this.screenShootCallBack})
      }
    },
    screenShootCallBack (base64) {
      // 把图片放到粘贴板里
      let node = document.createElement('img')
      node.setAttribute('style', 'max-width:100px')
      node.setAttribute('src', base64)
      node.setAttribute('class', 'local')
      // 把图片放到输入框里
      document.getElementById('input-main').appendChild(node) // 将img添加到div中

      this.$nextTick(() => {
        this.moveTo()// 把光标移至最后
      })

      // 复制图片节点
      let img2 = document.createElement('img')
      img2.setAttribute('style', 'width:100px;position: fixed; top: -5000px;')
      img2.setAttribute('src', base64)
      img2.setAttribute('class', 'screenShotImg')

      document.body.appendChild(img2)

      let target2 = document.querySelector('.screenShotImg')
      this.getSelect(target2)
      document.execCommand('copy')
      document.body.removeChild(target2)
    },
    // 选中图片
    getSelect (targetNode) {
      if (window.getSelection) {
        // chrome等主流浏览器
        let selection = window.getSelection()
        let range = document.createRange()
        range.selectNode(targetNode)
        selection.removeAllRanges()
        selection.addRange(range)
      } else if (document.body.createTextRange) {
        // ie
        let range = document.body.createTextRange()
        range.moveToElementText(targetNode)
        range.select()
      }
    },
    historyClick () {
      this.$emit('historyClick')
    },
    moreClick () { // 更多工具
      this.showMoreBar = !this.showMoreBar
    },
    openLickClick () { // 开单

    },
    moveTo (type = 'end') { // 移动光标到最后面
      let el = document.getElementById('input-main')
      el.focus()
      if (window.getSelection) { // ie11 10 9 ff safari
        let range = window.getSelection() // 创建range
        range.selectAllChildren(el) // 选择el子项
        if (type === 'start') {
          range.collapseToStart() // 光标移至开头
        } else {
          range.collapseToEnd() // 光标移至最后
        }
      } else if (document.selection) { // ie10 9 8 7 6 5
        let range = document.selection.createRange() // 创建选择对象
        range.moveToElementText(el) // range定位到ele
        if (type === 'start') {
          range.collapse() // 光标移至开头
        } else {
          range.collapse(false) // 光标移至最后
        }
        range.select()
      }
    },
    insertCont (html) { // 在光标处插入内容
      let el = document.getElementById('input-main')
      el.focus()
      if (document.selection) { // IE 10,9,8,7
        document.selection.createRange().pasteHTML(html)
      } else if (window.getSelection) {
        var sel = window.getSelection()
        if (sel.getRangeAt && sel.rangeCount) {
          var range = sel.getRangeAt(0)
          range.deleteContents()
          var div = document.createElement('div')
          div.innerHTML = html
          let frag = document.createDocumentFragment()
          let node
          let lastNode
          while ((node = div.firstChild)) {
            lastNode = frag.appendChild(node)
          }
          range.insertNode(frag)
          if (lastNode) {
            range = range.cloneRange()
            range.setStartAfter(lastNode)
            range.collapse(true)
            sel.removeAllRanges()
            sel.addRange(range)
          }
        }
      }
    },
    copyClick () {
      this.$emit('copyChat')
      this.closeMultiple()
    },
    closeMultiple () {
    //   this.multipleShow = false
      this.$emit('closeMultiple')
    }
  },
  beforeDestroy () {},
  destroyed () {},
  beforeUpdate () {},
  updated () {}
}
</script>
<style>
.emoji-pop{
    width: auto!important;
    max-width: 400px;
}
</style>
<style lang='scss' scoped>
.input-content{
        height: 20%;
        border-top: 1px solid rgba(0,0,0,0.12);
        position: relative;
        box-sizing: border-box;
        .toolbar{
            height: 40px;
            line-height: 40px;
            padding: 0 25px;
            >span{
                margin: 0 8px;
                cursor: pointer;
                transform: scale(1.3);
            }
            span:first-child{
                margin-left: 0px;
            }
            .send-icon{
                margin: 0 8px;
            }
            .big-size{
                font-size: 20px!important;
                .send-icon{
                    font-size: 24px;
                }
            }
            .file-upload{
                margin: 0 8px;
            }
        }
        .more-bar{
            width: 100%;
            height: calc(100% - 40px);
            background: #e5e5e5;
            position: absolute;
            bottom: 0;
            left: 0;
            display: flex;
            align-items: stretch;
            .one-box{
                text-align: center;
                width: 60px;
                height: 60px;
                margin: 10px;
                span{
                    margin-top: 8px;
                    display: inline-block;
                }
                .tool-box{
                    background: #fff;
                    border-radius: 10px;
                    width:100%;
                    height: 100%;
                    font-size: 30px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                /deep/ .el-upload{
                    .tool-box{
                        width: 60px;
                        height: 60px;
                        margin-top: 0px;
                    }
                }
            }
        }
        #input-main{
            width: 100%;
            height: 135px;
            border: none;
            resize: none;
            outline: none;
            padding: 5px 15px;
            overflow: auto;
            box-sizing: border-box;
            word-break: break-all;
            font-size: 16px;
        }
        .quest-num{
            float: right;
            color: #a3a3a3;
            margin-right: 20px;
            font-size: 20px;
        }
        #send{
            border: 0px;
            background: #f2f3f5;
            color: rgba(255, 125, 0, 1);
            font-size: 14px;
            float: right;
            height: 30px;
            line-height: 30px;
            margin-top: 5px;
            // width: 52px;
            padding: 0;
            cursor: pointer;
            outline: none;
        }
        .button-icon{
            font-size: 24px;
        }
        #emoji-box{
            width: 342px;
            height: 195px;
            position: absolute;
            top: -205px;
            left: 15px;
            background: #fff;
            box-shadow: 2px 0px 15px #bfbfbf;
            padding: 5px;
        }
        #emoji-box img{
            margin: 1px 3px;
        }
        .tool-disabled{
            color:#bfbfbf;
            pointer-events: none;
            cursor: none;
        }
        .tool-active{
            pointer-events: auto;
        }
        .top-toolbar{
            position: absolute;
            top: -32px;
            width: 100%;
            height: 32px;
            padding: 0px 10px;
            background: #cdcdcd;
            box-sizing: border-box;
        }
        .microphone-text {
            display: inline-block;
            line-height: 32px;
        }
        .green-ball {
            width: 8px;
            height: 8px;
            display: inline-block;
            border-radius: 10px;
            animation: colorChange 2s infinite;
        }
        @keyframes colorChange {
            0% {
                background: green;
            }
            50%{
                background: rgb(0, 206, 0);
            }
            100% {
                background: green;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// packages/chat/src/pc-input.vue